module.exports = __webpack_public_path__ + "static/media/ng.5fb28688.svg";